var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"mobile-navigator-sidebar",on:{"click":_vm.toggleSidebar}},[_c('app-icon',{attrs:{"icon":"shelf","is-active":_vm.isActive}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }